import {createReducer, on} from '@ngrx/store';
import {KundeTableActions} from '../actions/kunde-table.actions';
import {KundeEntitiesActions} from '../actions/kunde-entities.actions';
import {AbsenderColumn, KundeTableState} from '../states/kunde-table.state';
import {DirectionDTO} from '../../openapi/fakturierung-openapi';


export const initialKundeTableState: KundeTableState = {
  displayedIds: [],
  tableSettings: {
    _key: 'kontakt-table-settings-2026-04-02-0',
    _columns: [
      {
        id: AbsenderColumn.Kundennummer,
        name: 'Kundennummer',
        isActive: true,
        width: 160,
        overflow: 'break',
        sortable: false,
      }, {
        id: AbsenderColumn.Anrede,
        name: 'Anrede',
        isActive: false,
        width: 80,
        overflow: 'ellipsis',
        sortable: false,
      }, {
        id: AbsenderColumn.Titel,
        name: 'Titel',
        isActive: false,
        width: 80,
        overflow: 'ellipsis',
        sortable: false,
      }, {
        id: AbsenderColumn.NameVorname,
        name: 'Nachname, Vorname',
        isActive: true,
        width: 240,
        overflow: 'ellipsis',
        sortable: false,
      }, {
        id: AbsenderColumn.Firma,
        name: 'Firma',
        isActive: true,
        width: 240,
        overflow: 'break',
        sortable: false,
      }, {
        id: AbsenderColumn.StrasseUndHausnummer,
        name: 'Straße und Hausnummer',
        isActive: false,
        width: 320,
        overflow: 'break',
        sortable: false,
      }, {
        id: AbsenderColumn.Land,
        name: 'Land',
        isActive: false,
        width: 160,
        overflow: 'break',
        sortable: false,
      }, {
        id: AbsenderColumn.Plz,
        name: 'PLZ',
        isActive: false,
        width: 160,
        overflow: 'break',
        sortable: false,
      }, {
        id: AbsenderColumn.Ort,
        name: 'Ort',
        isActive: true,
        width: 160,
        overflow: 'break',
        sortable: false,
      }, {
        id: AbsenderColumn.Email,
        name: 'E-Mail-Adresse',
        isActive: false,
        width: 240,
        overflow: 'break',
        sortable: false,
      }, {
        id: AbsenderColumn.Besteuerungsform,
        name: 'Besteuerungsform',
        isActive: false,
        width: 192,
        overflow: 'ellipsis',
        sortable: false,
      }, {
        id: AbsenderColumn.UstNummer,
        name: 'USt-ID',
        isActive: false,
        width: 160,
        overflow: 'break',
        sortable: false,
      }, {
        id: AbsenderColumn.Steuernummer,
        name: 'Steuernummer',
        isActive: false,
        width: 192,
        overflow: 'break',
        sortable: false,
      }, {
        id: AbsenderColumn.Kontoinhaber,
        name: 'Kontoinhaber',
        isActive: false,
        width: 240,
        overflow: 'ellipsis',
        sortable: false,
      }, {
        id: AbsenderColumn.Iban,
        name: 'IBAN',
        isActive: false,
        width: 320,
        overflow: 'break',
        sortable: false,
      }, {
        id: AbsenderColumn.Actions,
        name: '',
        isActive: true,
        sortable: false,
      },
    ],
    _sortDirs: [],
    _sortParams: [],
  },
  pageableDto: {
    size: 50,
    number: 0,
    property: [
      'nachname',
      'vorname',
      'firmenbezeichnung',
    ],
    direction: [
      DirectionDTO.Asc,
      DirectionDTO.Asc,
      DirectionDTO.Asc,
    ],
  },
  totalPages: 0,
  kundenLoaded: false,
};

export const kundeTableReducer = createReducer(
  initialKundeTableState,

  on(KundeTableActions.setDisplayedIds, (state, {kundeDtos}) => ({
      ...state,
      displayedIds: kundeDtos.map(kundeDto => kundeDto.id),
      kundenLoaded: true,
    }),
  ),

  on(KundeTableActions.clearDisplayedKunden, (state) => ({
      ...state,
      displayedIds: [],
    }),
  ),

  on(KundeTableActions.changeTableSettings, (state, action) => ({
      ...state,
      tableSettings: action.tableSettings,
      // FIXME: Sort wird erst funktionieren wenn das Backend aktualisiert wurde.
      // pageableDto: {
      //   ...state.pageableDto,
      // https://gitlab.intern.landdata.de/land-data/fakturierung/fakturierung-service/-/issues/1
      // sort: {
      //   orders: [
      //     {
      //       direction: OrderDTODirectionEnum.Asc,
      //       ignoreCase: true,
      //       property: '',
      //     },
      //   ]
      // }
      // }
    })
  ),


  on(KundeTableActions.changePage, (state, action) => ({
      ...state,
      pageableDto: {
        ...state.pageableDto,
        ...action.pageableDto,
      },
    })
  ),

  on(KundeEntitiesActions.countKundenPagesSuccess, (state, {totalPages}) => ({
    ...state,
    totalPages,
  })),
);
